import { render } from "./NewTrashView.vue?vue&type=template&id=edcaaeaa&scoped=true"
import script from "./NewTrashView.vue?vue&type=script&lang=js"
export * from "./NewTrashView.vue?vue&type=script&lang=js"

import "./NewTrashView.vue?vue&type=style&index=0&id=edcaaeaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edcaaeaa"]])

export default __exports__